import type {CodeList} from '../../codelists/types';
import type {ManifestationV4} from '../types';
import {getProductFormText} from './getProductFormText';

type CodeLists = {
  productFormOverride?: CodeList;
  productForm?: CodeList;
  productFormDetails?: CodeList;
};

export const getManifestationValue = (
  manifestation: ManifestationV4,
  codelists: CodeLists,
): string => {
  const productFormText = getProductFormText({
    code: manifestation.productForm,
    detailsCode: manifestation.productFormDetail?.[0],
    codelists,
  });

  const fields = [
    manifestation.isbn,
    productFormText,
    manifestation.publishedYear,
  ].filter(f => !!f);

  return fields.join(' / ');
};
